import Http from './index.js'

export default class Model {
  constructor(path = '') {
    this.model = path
  }

  list(query = '', config = {}) {
    return Http.get(`${this.model}${query}`, config)
  }

  read(id, query = '', config = {}) {
    return Http.get(`${this.model}${id}/${query}`, config)
  }

  historic(id, query = '', config = {}) {
    return Http.get(`${this.model}${id}/historic/${query}`, config)
  }

  create(payload, config = {}) {
    return Http.post(this.model, payload, config)
  }

  update(id, obj, config = {}) {
    return Http.put(`${this.model}${id}/`, obj, config)
  }

  partialUpdate(id, obj, config = {}) {
    return Http.patch(`${this.model}${id}/`, obj, config)
  }

  delete(id, config = {}) {
    return Http.delete(this.model + id, config)
  }
}
